import React from 'react';

import DownloadButton from './downloadButton';

import { CardActions, FlatButton } from 'material-ui';
import CreateButton from 'admin-on-rest/lib/mui/button/CreateButton';
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh';


const BoatActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
}

export const Actions = ({ ...props, resource, filters, displayedFilters, filterValues, basePath, showFilter, refresh }) => (
  <CardActions style={BoatActionStyle}>
    {filters && React.cloneElement(filters, { resource, showFilter, displayedFilters, filterValues, context: 'button' }) }
    <CreateButton basePath={basePath} />
    <DownloadButton {...props} />
    <FlatButton primary label="refresh" onClick={refresh} icon={<NavigationRefresh />} />
  </CardActions>
);



// WEBPACK FOOTER //
// ./src/custom/actions.js